import Portal = require("portal-gis");
import Utils = require("../utils");
import Base = require("./base-command");
const log = Utils.log;

// this command triggers one or more events when one or more events have been triggered
class Command extends Base<any> {

    static about = `
Usage Example:

    <EVENT about="Each time reverse-geoquery initiates wait until both the address and parcel search returns before raising show-coordinates" event="reverse-geoquery" id="reverse-geoquery-multiplexer" mid="app/commands/multiplexer">
    <OPTIONS>
        <Values about="Only do this once per &quot;use-this-parcel&quot; event" id="once" value="true" />
        <Values id="in" value="add-to-address-layer,add-to-parcel-layer,associated-addresses,find-associated-addresses" />
        <Values about="civics:map-click-results is picked up by liferay-interpreter and given to civics, notify show-coordinates so it can render a location marker if no features are found" id="out" value="show-coordinates,civics:map-click-results" />
    </OPTIONS>
    </EVENT>

    `;

    static options = Utils.defaults({
        "in": {
            "about": "Event(s) that must occur before triggering _out_ events",
        },
        "once": {
            "about": "Only do this once per event",
        },
        "out": {
            "about": "Event(s) to trigger once all _in_ event have been received.",
        },
    }, Base.options);

    execute(args: any = this.args) {

        let once = this.findOption("once") === "true";
        let input_events = Utils.split(this.findOption("in") || "");
        let output_events = Utils.split(this.findOption("out") || "");
        let trace = this.options["trace"] === "true";

        let handles = <Array<{ off: () => void }>>[];

        let doit = () => {

            let abort = false;
            let waitingOn = input_events.map(v => v);

            let waits = input_events.map(eventName => {
                let d = $.Deferred<
                    {
                        eventName: string;
                        eventArgs: any;
                    }
                    >();
                let h = this.mediator.on(eventName, args => {
                    waitingOn.splice(waitingOn.indexOf(eventName), 1);
                    if (trace) {
                        console.log(`multiplexer ${this.configuration.id} received: ${eventName}, waiting on: ${waitingOn.join(",")}`);
                    }
                    h.off();
                    d.resolve({
                        eventName: eventName,
                        eventArgs: args
                    });
                });
                handles.push(h);
                return d;
            });

            Utils.split((<Portal.EventsLeaf>this.configuration).name).map(eventName => {
                let h = this.mediator.on(eventName, args => {
                    trace && console.log(`${eventName} forcing multiplexer ${this.configuration.id} to abort`);
                    handles.forEach(h => h.off());
                    handles = [];
                    waits.forEach(h => h.reject("aborted"));
                });
                handles.push(h);
            });

            $.when.apply($, waits).done((...args: {
                eventName: string;
                eventArgs: any;
            }[]) => {
                log(`multiplexer ${this.configuration.id} executing`);
                // stop listening for abort events
                handles.forEach(h => h.off());
                handles = [];

                output_events.forEach(eventName => {
                    this.trigger(eventName, {
                        events: args
                    });
                });

                this.trigger({
                    events: args
                });

                if (!once) doit();
            });
        };

        doit();

        this.trigger();
    }

}

export = Command; 